let transitionEndEvent;
const defaultDuration = 500;
const el = document.createElement('berkin');
const transitions = {
	transition: 'transitionend',
	OTransition: 'oTransitionEnd otransitionend',
	MozTransition: 'transitionend',
	WebkitTransition: 'webkitTransitionEnd'
};

Object.keys(transitions).forEach((name) => {
	if (el.style[name] !== undefined) {
		transitionEndEvent = transitions[name];
	}
});


function transitionEndWrapper(element, handler, duration) {
	let called = false;
	function callback() {
		if (!called) {
			handler.call(this, element);
			called = true;
		}

		if (transitionEndEvent) {
			element.removeEventListener(transitionEndEvent, callback);
		}
	}

	if (transitionEndEvent) {
		element.addEventListener(transitionEndEvent, callback);
	}

	setTimeout(callback, duration || defaultDuration);
}

export default transitionEndWrapper;



// WEBPACK FOOTER //
// ./mobile-core/src/utils/transition-end.js